import { render, staticRenderFns } from "./InsNotice.vue?vue&type=template&id=4ac1761c&scoped=true&"
import script from "./InsNotice.vue?vue&type=script&lang=ts&"
export * from "./InsNotice.vue?vue&type=script&lang=ts&"
import style0 from "./InsNotice.vue?vue&type=style&index=0&id=4ac1761c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1761c",
  null
  
)

export default component.exports